var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"main-logo NuxtLogo",attrs:{"slot":"label","src":require("../assets/relink-main-logo-black.png")},slot:"label"})}
var staticRenderFns = []

export { render, staticRenderFns }